import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../contexts/auth/useAuth';
import { useApi } from './useApi';

export function useZendeskJwt() {
  const { makeApiRequest } = useApi();
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: ['zendesk-jwt'],
    queryFn: () => makeApiRequest<{ action: string; jwt: string }>('/auth/zendesk-sso', 'GET'),
    staleTime: 60 * 60 * 1000, // 1 hour
    enabled: isAuthenticated,
  });
}
